// Each card's three printed editions (Base, Foil, Serialized), by card id, from the
// signed production catalog (contracts/releases/prd/artifacts/catalog.json): the
// name printed on its face, its on-chain edition id, supply and face CID. A CID
// that several editions share is the catalog's generic stand-in for art not yet
// revealed, so it is null here. Generated; src/lib/public-cards.test.ts keeps this,
// the catalog and client.html's CARD_CID in step.
export const ART_HOST = "https://assets.mudwater.bayc.com";
export const CARD_EDITIONS = {
  "001": [
    {
      finish: "Base",
      name: "Bottle Rocket",
      catalogId: "001",
      onchainEditionId: 0,
      maxSupply: 21878,
      cid: "bafkreieiwjvwf5ql2emk4axbmhxtt55sr3jqq6r57cp2velfkthf5vibgu",
    },
    {
      finish: "Foil",
      name: "Bottle Rocket",
      catalogId: "F001",
      onchainEditionId: 120,
      maxSupply: 2352,
      cid: "bafkreieze3rp7um3bjtz2ckw4gxws3konlwfdb5uapa7peym4v3x2znimu",
    },
    {
      finish: "Serialized",
      name: "Bottle Rocket",
      catalogId: "SE001",
      onchainEditionId: 240,
      maxSupply: 99,
      cid: null,
    },
  ],
  "002": [
    {
      finish: "Base",
      name: "Sea Dog",
      catalogId: "002",
      onchainEditionId: 1,
      maxSupply: 21878,
      cid: "bafkreibwbzat6k737zs5pol3fl7nqkb6xbu3jgq4njfx2ffa6h5x3jozbi",
    },
    {
      finish: "Foil",
      name: "Sea Dog",
      catalogId: "F002",
      onchainEditionId: 121,
      maxSupply: 2352,
      cid: "bafkreid7ay6cv5xc3ieybuuqvqisy2tdderwvs4xre2qhepil5p7ek4w2u",
    },
    {
      finish: "Serialized",
      name: "Sea Dog",
      catalogId: "SE002",
      onchainEditionId: 241,
      maxSupply: 99,
      cid: null,
    },
  ],
  "003": [
    {
      finish: "Base",
      name: "The Deckhand",
      catalogId: "003",
      onchainEditionId: 2,
      maxSupply: 21878,
      cid: "bafkreief4d7jhs46exn6ozuduikp2rwnkr6o4ypw3nova4fmwxuzqg6tmu",
    },
    {
      finish: "Foil",
      name: "The Deckhand",
      catalogId: "F003",
      onchainEditionId: 122,
      maxSupply: 2352,
      cid: "bafkreid2pa4dvpsu57hzu6ubf4ze7f25huvs4mtn7g3funcyvv6tx5uuey",
    },
    {
      finish: "Serialized",
      name: "The Deckhand",
      catalogId: "SE003",
      onchainEditionId: 242,
      maxSupply: 99,
      cid: null,
    },
  ],
  "004": [
    {
      finish: "Base",
      name: "The Boathouse",
      catalogId: "004",
      onchainEditionId: 3,
      maxSupply: 21878,
      cid: "bafkreibsw5maslfw45jbivfnfpsdcy77mvoh5z2uw5nfzpdd64m346xyla",
    },
    {
      finish: "Foil",
      name: "The Boathouse",
      catalogId: "F004",
      onchainEditionId: 123,
      maxSupply: 2352,
      cid: "bafkreiekuu5hmopfrntbhuai4ktt7cwvrtbkozosd52xs4qgft3s2l4exy",
    },
    {
      finish: "Serialized",
      name: "The Boathouse",
      catalogId: "SE004",
      onchainEditionId: 243,
      maxSupply: 99,
      cid: null,
    },
  ],
  "005": [
    {
      finish: "Base",
      name: "Dead Calm",
      catalogId: "005",
      onchainEditionId: 4,
      maxSupply: 24060,
      cid: "bafkreidtd6pezmxucpnk2dizpzrxvaqitn5tu3rle3qedun34lhcptqefi",
    },
    {
      finish: "Foil",
      name: "Dead Calm",
      catalogId: "F005",
      onchainEditionId: 124,
      maxSupply: 2587,
      cid: "bafkreicamimgx76o5ffkv3jljmddn2oj2ezx2tmx6t5bcxeb2n32cfsbum",
    },
    {
      finish: "Serialized",
      name: "Dead Calm",
      catalogId: "SE005",
      onchainEditionId: 244,
      maxSupply: 50,
      cid: null,
    },
  ],
  "006": [
    {
      finish: "Base",
      name: "The Dive",
      catalogId: "006",
      onchainEditionId: 5,
      maxSupply: 24060,
      cid: "bafkreifhqv6hfk3ucotaidfnekxvw6w4gsgtscvqmlx535xibecoub2ivq",
    },
    {
      finish: "Foil",
      name: "The Dive",
      catalogId: "F006",
      onchainEditionId: 125,
      maxSupply: 2587,
      cid: "bafkreib7yggtv7oywsvttx7c6iu2oqx43xg3qnfhwaqvhvcejuwl564q3m",
    },
    {
      finish: "Serialized",
      name: "The Dive",
      catalogId: "SE006",
      onchainEditionId: 245,
      maxSupply: 50,
      cid: null,
    },
  ],
  "007": [
    {
      finish: "Base",
      name: "Clubhouse Wake",
      catalogId: "007",
      onchainEditionId: 6,
      maxSupply: 24060,
      cid: "bafkreih3psmfrzefnelgxkcccpdgt6yipbcqcemu5y4wmasmet2p2u6hxy",
    },
    {
      finish: "Foil",
      name: "Clubhouse Wake",
      catalogId: "F007",
      onchainEditionId: 126,
      maxSupply: 2587,
      cid: "bafkreidp23gtisfokqjfo2z5qwo7bytozaqszk6ysfxdxd7pb6u4tg57hi",
    },
    {
      finish: "Serialized",
      name: "Clubhouse Wake",
      catalogId: "SE007",
      onchainEditionId: 246,
      maxSupply: 50,
      cid: null,
    },
  ],
  "008": [
    {
      finish: "Base",
      name: "Lofi on the Dock",
      catalogId: "008",
      onchainEditionId: 7,
      maxSupply: 3626,
      cid: "bafkreid7i73gdh6iy5pu54yedjqbekoatctd2caey6wgqh5qi3moa7tnhi",
    },
    {
      finish: "Foil",
      name: "Lofi on the Dock",
      catalogId: "F008",
      onchainEditionId: 127,
      maxSupply: 384,
      cid: "bafkreiaqfaunlhk3dn2rd25xpoypysnlf652opxr6ykik5sb7pmmczrbnm",
    },
    {
      finish: "Serialized",
      name: "Lofi on the Dock",
      catalogId: "SE008",
      onchainEditionId: 247,
      maxSupply: 5,
      cid: "bafkreidzgbahaeqmx2md6rifhph3o6k4cmzyj7jg2oaxsbmqgdu3zbhlm4",
    },
  ],
  "009": [
    {
      finish: "Base",
      name: "The Skipper",
      catalogId: "009",
      onchainEditionId: 8,
      maxSupply: 13906,
      cid: "bafkreicuoub7exj7g6ae7wj6fpfzijx5hqhxr7d2pmkn7yku54njeo7mme",
    },
    {
      finish: "Foil",
      name: "The Skipper",
      catalogId: "F009",
      onchainEditionId: 128,
      maxSupply: 1493,
      cid: "bafkreiduflf4rda5rmiiykabq7gqdnbo6qb2qy4w2epxbbmsfpbff4x5zi",
    },
    {
      finish: "Serialized",
      name: "The Skipper",
      catalogId: "SE009",
      onchainEditionId: 248,
      maxSupply: 10,
      cid: null,
    },
  ],
  "010": [
    {
      finish: "Base",
      name: "Off Duty",
      catalogId: "010",
      onchainEditionId: 9,
      maxSupply: 21878,
      cid: "bafkreia6ehfh6rayokeszxoabm7rjoxk34y4pakuhplsxd7cicn5r5lzlq",
    },
    {
      finish: "Foil",
      name: "Off Duty",
      catalogId: "F010",
      onchainEditionId: 129,
      maxSupply: 2352,
      cid: "bafkreianqwtng7zx6qnyupag5yckzou5orzexyhwhyjsie5y22bljaf2te",
    },
    {
      finish: "Serialized",
      name: "Off Duty",
      catalogId: "SE010",
      onchainEditionId: 249,
      maxSupply: 99,
      cid: null,
    },
  ],
  "011": [
    {
      finish: "Base",
      name: "The Drowned Captain",
      catalogId: "011",
      onchainEditionId: 10,
      maxSupply: 21878,
      cid: "bafkreibdiopoxchrpzjbw34tqskwvk6olgbxr7bu2gpusbaszxjd5pgmya",
    },
    {
      finish: "Foil",
      name: "The Drowned Captain",
      catalogId: "F011",
      onchainEditionId: 130,
      maxSupply: 2352,
      cid: "bafkreifm3t5fdgxp3mshehovhkau7rystysuekf5l3vz3fep6hrwelmmay",
    },
    {
      finish: "Serialized",
      name: "The Drowned Captain",
      catalogId: "SE011",
      onchainEditionId: 250,
      maxSupply: 99,
      cid: null,
    },
  ],
  "012": [
    {
      finish: "Base",
      name: "Good Seats",
      catalogId: "012",
      onchainEditionId: 11,
      maxSupply: 21878,
      cid: "bafkreiay2uyvwtnaju2lu4rx45krn6h3qxhnzw4glnhk4wypn4rpm2o4zm",
    },
    {
      finish: "Foil",
      name: "Good Seats",
      catalogId: "F012",
      onchainEditionId: 131,
      maxSupply: 2352,
      cid: "bafkreiav4vxqdvgydmb2ktkmfydkroussngfepduyijvgwi5i3g5ek2bgu",
    },
    {
      finish: "Serialized",
      name: "Good Seats",
      catalogId: "SE012",
      onchainEditionId: 251,
      maxSupply: 99,
      cid: null,
    },
  ],
  "013": [
    {
      finish: "Base",
      name: "The Blue Voyage",
      catalogId: "013",
      onchainEditionId: 12,
      maxSupply: 24060,
      cid: "bafkreiey2kwoe4gsjonltmgmqvregdsdhlowquiimzf7ujygg3kvl4q5wu",
    },
    {
      finish: "Foil",
      name: "The Blue Voyage",
      catalogId: "F013",
      onchainEditionId: 132,
      maxSupply: 2587,
      cid: "bafkreiczxz3yo3yricmskxmdj2r5enkj2joxgqjbfdtkltytbymq77xehy",
    },
    {
      finish: "Serialized",
      name: "The Blue Voyage",
      catalogId: "SE013",
      onchainEditionId: 252,
      maxSupply: 50,
      cid: null,
    },
  ],
  "014": [
    {
      finish: "Base",
      name: "Members Only",
      catalogId: "014",
      onchainEditionId: 13,
      maxSupply: 21878,
      cid: "bafkreidyrelqg6h254epjbysha5ljockslqxl46phu5vw7ul6lbp2lelam",
    },
    {
      finish: "Foil",
      name: "Members Only",
      catalogId: "F014",
      onchainEditionId: 133,
      maxSupply: 2352,
      cid: "bafkreid7fka5jhfygppxtrnc4qowjog5plhnn3kdjxyyaeediabpryeofq",
    },
    {
      finish: "Serialized",
      name: "Members Only",
      catalogId: "SE014",
      onchainEditionId: 253,
      maxSupply: 99,
      cid: null,
    },
  ],
  "015": [
    {
      finish: "Base",
      name: "The Lighter",
      catalogId: "015",
      onchainEditionId: 14,
      maxSupply: 21878,
      cid: "bafkreig3ljglzpbtojb4calf3rm6j2wn4tt3ynh6huk5usp5omdzgxqj6u",
    },
    {
      finish: "Foil",
      name: "The Lighter",
      catalogId: "F015",
      onchainEditionId: 134,
      maxSupply: 2352,
      cid: "bafkreiai2nj6ia5gl4tl3ymmhivewrtu4lfgmzy4dnljwaimltsyztt2ne",
    },
    {
      finish: "Serialized",
      name: "The Lighter",
      catalogId: "SE015",
      onchainEditionId: 254,
      maxSupply: 99,
      cid: null,
    },
  ],
  "016": [
    {
      finish: "Base",
      name: "Havana Gold",
      catalogId: "016",
      onchainEditionId: 15,
      maxSupply: 21878,
      cid: "bafkreiecoojn6gcdhl5fvhxm6363iwvfpt2dznfwwy5bpvgv5gln7jm6uu",
    },
    {
      finish: "Foil",
      name: "Havana Gold",
      catalogId: "F016",
      onchainEditionId: 135,
      maxSupply: 2352,
      cid: "bafkreigyyrlfkve6k4l65vl342ylqz55skyfkryge7hnoqrtub5k6dyreq",
    },
    {
      finish: "Serialized",
      name: "Havana Gold",
      catalogId: "SE016",
      onchainEditionId: 255,
      maxSupply: 99,
      cid: null,
    },
  ],
  "017": [
    {
      finish: "Base",
      name: "The Ante",
      catalogId: "017",
      onchainEditionId: 16,
      maxSupply: 21878,
      cid: "bafkreibqouqs4px6mcqpu4hb63rj27nxhl25ucfons4tdtrreqrnogtg44",
    },
    {
      finish: "Foil",
      name: "The Ante",
      catalogId: "F017",
      onchainEditionId: 136,
      maxSupply: 2352,
      cid: "bafkreibxrhnyu52a5bzul4vorzo5soeyzkmkdx536m7g3uceosxyzlrlwm",
    },
    {
      finish: "Serialized",
      name: "The Ante",
      catalogId: "SE017",
      onchainEditionId: 256,
      maxSupply: 99,
      cid: null,
    },
  ],
  "018": [
    {
      finish: "Base",
      name: "Neon Bronco",
      catalogId: "018",
      onchainEditionId: 17,
      maxSupply: 21878,
      cid: "bafkreicotuswywxeu6f645sjp5gbsjjkc6ta2gizndg7ecc3dqdlcrufxa",
    },
    {
      finish: "Foil",
      name: "Neon Bronco",
      catalogId: "F018",
      onchainEditionId: 137,
      maxSupply: 2352,
      cid: "bafkreidd4s5vfq65filpymwr36qmiy5he4mof3k7wuti4n3rg73q7m25qu",
    },
    {
      finish: "Serialized",
      name: "Neon Bronco",
      catalogId: "SE018",
      onchainEditionId: 257,
      maxSupply: 99,
      cid: null,
    },
  ],
  "019": [
    {
      finish: "Base",
      name: "The Captain",
      catalogId: "019",
      onchainEditionId: 18,
      maxSupply: 24060,
      cid: "bafkreihowvqpzzn54kjv32h6pf5mvc76jqjsw5nv2xfdrqawf3jdk66d4i",
    },
    {
      finish: "Foil",
      name: "The Captain",
      catalogId: "F019",
      onchainEditionId: 138,
      maxSupply: 2587,
      cid: "bafkreied2ayalgejj3mjwsqpsqf74thaouewwqbdkrdqge3yb7wzvfex6i",
    },
    {
      finish: "Serialized",
      name: "The Captain",
      catalogId: "SE019",
      onchainEditionId: 258,
      maxSupply: 50,
      cid: null,
    },
  ],
  "020": [
    {
      finish: "Base",
      name: "The Parlor Regular",
      catalogId: "020",
      onchainEditionId: 19,
      maxSupply: 24060,
      cid: "bafkreicygsnbgsb7aqhu4r4ccqpzkfyeldk45yss7ve53vsooip3qstsdy",
    },
    {
      finish: "Foil",
      name: "The Parlor Regular",
      catalogId: "F020",
      onchainEditionId: 139,
      maxSupply: 2587,
      cid: "bafkreidmugcc4pn34algnpmaejyreqsovhsgtut7ndyunzixkk2abkh4iq",
    },
    {
      finish: "Serialized",
      name: "The Parlor Regular",
      catalogId: "SE020",
      onchainEditionId: 259,
      maxSupply: 50,
      cid: null,
    },
  ],
  "021": [
    {
      finish: "Base",
      name: "Hot Table",
      catalogId: "021",
      onchainEditionId: 20,
      maxSupply: 3626,
      cid: "bafkreiaa7dltzo74wuu7dqy23o6epuzu3p3cfippy4g4zw56fnf6x46dgy",
    },
    {
      finish: "Foil",
      name: "Hot Table",
      catalogId: "F021",
      onchainEditionId: 140,
      maxSupply: 384,
      cid: "bafkreihbshvmvthtf64yk6pkngkbf4yf6lphccsj27uhiamtl6xpzomeji",
    },
    {
      finish: "Serialized",
      name: "Hot Table",
      catalogId: "SE021",
      onchainEditionId: 260,
      maxSupply: 5,
      cid: "bafkreibu3enfbyv6dodeaw4t4lis643uvvaeoxzmrun3wal5pkfelekk5q",
    },
  ],
  "022": [
    {
      finish: "Base",
      name: "Last Call",
      catalogId: "022",
      onchainEditionId: 21,
      maxSupply: 3626,
      cid: "bafkreibukibbj6xkvpj4itxza7pejibwezmh7ihghdljzakfkvm3mzxzzq",
    },
    {
      finish: "Foil",
      name: "Last Call",
      catalogId: "F022",
      onchainEditionId: 141,
      maxSupply: 384,
      cid: "bafkreiagzsllzqzamo4lubvrvzmkp74cwiypmujqfb4lkigxvssllwte2q",
    },
    {
      finish: "Serialized",
      name: "Last Call",
      catalogId: "SE022",
      onchainEditionId: 261,
      maxSupply: 5,
      cid: "bafkreie6tfk3vja6orubac7xmo6a7i6vqg3s4oq24uamhichjw3kpuuqxi",
    },
  ],
  "023": [
    {
      finish: "Base",
      name: "Face Card",
      catalogId: "023",
      onchainEditionId: 22,
      maxSupply: 21878,
      cid: "bafkreigwvqdwnbi7mskk5svkta7crwqkod7t5cxnbyvvtcekfvo4bu43bu",
    },
    {
      finish: "Foil",
      name: "Face Card",
      catalogId: "F023",
      onchainEditionId: 142,
      maxSupply: 2352,
      cid: "bafkreidgfikuar6yibdyoytncv5s665ciom25lof2j4ss4ar6g3etjmdra",
    },
    {
      finish: "Serialized",
      name: "Face Card",
      catalogId: "SE023",
      onchainEditionId: 262,
      maxSupply: 99,
      cid: null,
    },
  ],
  "024": [
    {
      finish: "Base",
      name: "Four of a Kind",
      catalogId: "024",
      onchainEditionId: 23,
      maxSupply: 21878,
      cid: "bafkreighl4hqgou2eqchianmcbf4dicl5lkhwruqvnxxrf7a4vkdi5oxcy",
    },
    {
      finish: "Foil",
      name: "Four of a Kind",
      catalogId: "F024",
      onchainEditionId: 143,
      maxSupply: 2352,
      cid: "bafkreiguypz3ch3ggxjy7cir4iupef4yjku7s4b4gbft2kmwnekhvcmbui",
    },
    {
      finish: "Serialized",
      name: "Four of a Kind",
      catalogId: "SE024",
      onchainEditionId: 263,
      maxSupply: 99,
      cid: null,
    },
  ],
  "025": [
    {
      finish: "Base",
      name: "The Getaway",
      catalogId: "025",
      onchainEditionId: 24,
      maxSupply: 21878,
      cid: "bafkreifgkpengdgyuemi44wkgrcvrcz4j3facedomwzrvatjhkhdp2wgpu",
    },
    {
      finish: "Foil",
      name: "The Getaway",
      catalogId: "F025",
      onchainEditionId: 144,
      maxSupply: 2352,
      cid: "bafkreiburxtfgxelvxznlcd2qs5tflzowzy6wap7i5zjje3ectb2dh324u",
    },
    {
      finish: "Serialized",
      name: "The Getaway",
      catalogId: "SE025",
      onchainEditionId: 264,
      maxSupply: 99,
      cid: null,
    },
  ],
  "026": [
    {
      finish: "Base",
      name: "Bored Stiff",
      catalogId: "026",
      onchainEditionId: 25,
      maxSupply: 21878,
      cid: "bafkreiebtni7aerh2wzrkahsj33ceoxp4s44dkg3tqshtaneznrsm7tb3y",
    },
    {
      finish: "Foil",
      name: "Bored Stiff",
      catalogId: "F026",
      onchainEditionId: 145,
      maxSupply: 2352,
      cid: "bafkreidw2yqjj7wao3wqc3zunjo7wfs42ojfjcuwloasamdomnowcbkkxq",
    },
    {
      finish: "Serialized",
      name: "Bored Stiff",
      catalogId: "SE026",
      onchainEditionId: 265,
      maxSupply: 99,
      cid: null,
    },
  ],
  "027": [
    {
      finish: "Base",
      name: "Couch Lock",
      catalogId: "027",
      onchainEditionId: 26,
      maxSupply: 21878,
      cid: "bafkreifoytwkehfzpi5pu4gflstakc2grxyt3l5p3gldidxzxxshnl67e4",
    },
    {
      finish: "Foil",
      name: "Couch Lock",
      catalogId: "F027",
      onchainEditionId: 146,
      maxSupply: 2352,
      cid: "bafkreias3vytkoasv3fmhgnql7kr3tctr5zm5fvrng3ftp7z3s37imwi3a",
    },
    {
      finish: "Serialized",
      name: "Couch Lock",
      catalogId: "SE027",
      onchainEditionId: 266,
      maxSupply: 99,
      cid: null,
    },
  ],
  "028": [
    {
      finish: "Base",
      name: "The Back Room",
      catalogId: "028",
      onchainEditionId: 27,
      maxSupply: 21878,
      cid: "bafkreibxievq3kgx7stn75pzixckhg5ifjo3i3mrxwibgagyxoh5a7z4hq",
    },
    {
      finish: "Foil",
      name: "The Back Room",
      catalogId: "F028",
      onchainEditionId: 147,
      maxSupply: 2352,
      cid: "bafkreid2p6xi4hjk373lozltsu7qgcz55c2r4ubmst2mgpjbevbxiufsci",
    },
    {
      finish: "Serialized",
      name: "The Back Room",
      catalogId: "SE028",
      onchainEditionId: 267,
      maxSupply: 99,
      cid: null,
    },
  ],
  "029": [
    {
      finish: "Base",
      name: "The Arcade",
      catalogId: "029",
      onchainEditionId: 28,
      maxSupply: 24060,
      cid: "bafkreihhvopyxk6ubl5pvegqlmpyy64ef2vbdtelausgwu47b55gi7lyne",
    },
    {
      finish: "Foil",
      name: "The Arcade",
      catalogId: "F029",
      onchainEditionId: 148,
      maxSupply: 2587,
      cid: "bafkreibtvpoj2dflzsz45pqfxhuwbkqmg4ohsvl5qmewfxz5rkghwpurk4",
    },
    {
      finish: "Serialized",
      name: "The Arcade",
      catalogId: "SE029",
      onchainEditionId: 268,
      maxSupply: 50,
      cid: null,
    },
  ],
  "030": [
    {
      finish: "Base",
      name: "Book of Apes",
      catalogId: "030",
      onchainEditionId: 29,
      maxSupply: 24060,
      cid: "bafkreia7tr5uokip2tgyeydcehzjgrlupxukrpnh37vapdqata6y4wf4q4",
    },
    {
      finish: "Foil",
      name: "Book of Apes",
      catalogId: "F030",
      onchainEditionId: 149,
      maxSupply: 2587,
      cid: "bafkreif6ro3lfecb5lftl3i74chqeds3ihx5bpyujj6rtfbtngqhkguwbi",
    },
    {
      finish: "Serialized",
      name: "Book of Apes",
      catalogId: "SE030",
      onchainEditionId: 269,
      maxSupply: 50,
      cid: null,
    },
  ],
  "031": [
    {
      finish: "Base",
      name: "Golden Stacks",
      catalogId: "031",
      onchainEditionId: 30,
      maxSupply: 24060,
      cid: "bafkreifx62vnwno2rq3tcgw7nv2wf5lnnxqk52p7kfsij6fovmqgtzqnhm",
    },
    {
      finish: "Foil",
      name: "Golden Stacks",
      catalogId: "F031",
      onchainEditionId: 150,
      maxSupply: 2587,
      cid: "bafkreignufhitoockw5ze2t3k4bwrgkiaqixo4gwq5277hfwzkeqxgi7im",
    },
    {
      finish: "Serialized",
      name: "Golden Stacks",
      catalogId: "SE031",
      onchainEditionId: 270,
      maxSupply: 50,
      cid: null,
    },
  ],
  "032": [
    {
      finish: "Base",
      name: "The Game Room",
      catalogId: "032",
      onchainEditionId: 31,
      maxSupply: 21878,
      cid: "bafkreig5ohxjqvhmkvjfrn4jv6p3dn6delwhmftgrmqnkkzlir55nlngrq",
    },
    {
      finish: "Foil",
      name: "The Game Room",
      catalogId: "F032",
      onchainEditionId: 151,
      maxSupply: 2352,
      cid: "bafkreihiqymidsicvwffvl36ltimxwax6t3hfuy6uf3ci3i6ywyig4sami",
    },
    {
      finish: "Serialized",
      name: "The Game Room",
      catalogId: "SE032",
      onchainEditionId: 271,
      maxSupply: 99,
      cid: null,
    },
  ],
  "033": [
    {
      finish: "Base",
      name: "Swinging Doors",
      catalogId: "033",
      onchainEditionId: 32,
      maxSupply: 3626,
      cid: "bafkreiggjtasczzvjgyzsxhbusdvvmmm3wbohom4c56hwjfvk75ixhj3t4",
    },
    {
      finish: "Foil",
      name: "Swinging Doors",
      catalogId: "F033",
      onchainEditionId: 152,
      maxSupply: 384,
      cid: "bafkreiazyxbpmus5mibsnooyfo6w55pnhojybzd3yoznubuqmmjbn5ddxy",
    },
    {
      finish: "Serialized",
      name: "Swinging Doors",
      catalogId: "SE033",
      onchainEditionId: 272,
      maxSupply: 5,
      cid: "bafkreifyjoo22ums24omcyqj67mc63foakyhlpfiogq2ot5opsilhy4asa",
    },
  ],
  "034": [
    {
      finish: "Base",
      name: "Bored at the Door",
      catalogId: "034",
      onchainEditionId: 33,
      maxSupply: 13906,
      cid: "bafkreiftj7o76br77ex4gmrqpbkezbesbvw6k4zap7jfawulbh622xcidu",
    },
    {
      finish: "Foil",
      name: "Bored at the Door",
      catalogId: "F034",
      onchainEditionId: 153,
      maxSupply: 1493,
      cid: "bafkreiapfn3fqi2es4gacfulnkdhybv5htseumep327oc5tpfcyexgls7y",
    },
    {
      finish: "Serialized",
      name: "Bored at the Door",
      catalogId: "SE034",
      onchainEditionId: 273,
      maxSupply: 10,
      cid: null,
    },
  ],
  "035": [
    {
      finish: "Base",
      name: "Basement Anchor",
      catalogId: "035",
      onchainEditionId: 34,
      maxSupply: 21878,
      cid: "bafkreigei5hvlirk3oqlfaskmzoenv7ghgpqbkyciujmmlkkzhgdbivir4",
    },
    {
      finish: "Foil",
      name: "Basement Anchor",
      catalogId: "F035",
      onchainEditionId: 154,
      maxSupply: 2352,
      cid: "bafkreig4ml7c5tespccv6sluzrm2n635lh72hdphb3ofhakg4ms3sxwlui",
    },
    {
      finish: "Serialized",
      name: "Basement Anchor",
      catalogId: "SE035",
      onchainEditionId: 274,
      maxSupply: 99,
      cid: null,
    },
  ],
  "036": [
    {
      finish: "Base",
      name: "The Shortcut",
      catalogId: "036",
      onchainEditionId: 35,
      maxSupply: 24060,
      cid: "bafkreibwqbdurqhtbdhnlcs4vmgumoriierm73dkeffoh6dcmtywo2yjsm",
    },
    {
      finish: "Foil",
      name: "The Shortcut",
      catalogId: "F036",
      onchainEditionId: 155,
      maxSupply: 2587,
      cid: "bafkreicrlmuc2jelcwkvgyzakpycoj5ztz6usyuz3vlqp2ufjmz2waeody",
    },
    {
      finish: "Serialized",
      name: "The Shortcut",
      catalogId: "SE036",
      onchainEditionId: 275,
      maxSupply: 50,
      cid: null,
    },
  ],
  "037": [
    {
      finish: "Base",
      name: "Away Game",
      catalogId: "037",
      onchainEditionId: 36,
      maxSupply: 24060,
      cid: "bafkreigdtfrytxubl6kbtymyaygtz6yxgssvkterjl6nzvfx4r7et6h2em",
    },
    {
      finish: "Foil",
      name: "Away Game",
      catalogId: "F037",
      onchainEditionId: 156,
      maxSupply: 2587,
      cid: "bafkreiggkhsshdqrvynopfxjpk5gk56koqname2iprmu5cskfieknkacri",
    },
    {
      finish: "Serialized",
      name: "Away Game",
      catalogId: "SE037",
      onchainEditionId: 276,
      maxSupply: 50,
      cid: null,
    },
  ],
  "038": [
    {
      finish: "Base",
      name: "Bored & Loathing",
      catalogId: "038",
      onchainEditionId: 37,
      maxSupply: 13906,
      cid: "bafkreibttueqr4b4r4bo54z2pvnit3dk23hr2nshpko4pt6zyvk4mmimki",
    },
    {
      finish: "Foil",
      name: "Bored & Loathing",
      catalogId: "F038",
      onchainEditionId: 157,
      maxSupply: 1493,
      cid: "bafkreidn4v32h3mfx76fzesdkyymgdlbmha5iklvozwde5ekalsuds4clq",
    },
    {
      finish: "Serialized",
      name: "Bored & Loathing",
      catalogId: "SE038",
      onchainEditionId: 277,
      maxSupply: 10,
      cid: null,
    },
  ],
  "039": [
    {
      finish: "Base",
      name: "Cold Summit",
      catalogId: "039",
      onchainEditionId: 38,
      maxSupply: 21878,
      cid: "bafkreiapjsvalhl2v6o35anhm74ut4o5o4y2ubcdbcqjqv3duso3ahhlcm",
    },
    {
      finish: "Foil",
      name: "Cold Summit",
      catalogId: "F039",
      onchainEditionId: 158,
      maxSupply: 2352,
      cid: "bafkreib77qne7jslz6u75buwuhve6sviadqwgghqsffcko66bcluumruki",
    },
    {
      finish: "Serialized",
      name: "Cold Summit",
      catalogId: "SE039",
      onchainEditionId: 278,
      maxSupply: 99,
      cid: null,
    },
  ],
  "040": [
    {
      finish: "Base",
      name: "The Moai",
      catalogId: "040",
      onchainEditionId: 39,
      maxSupply: 24060,
      cid: "bafkreib7hfwnx65bnnf7arrlc7327uqlqsiljhpypczmgnhgxcaqsfjo6u",
    },
    {
      finish: "Foil",
      name: "The Moai",
      catalogId: "F040",
      onchainEditionId: 159,
      maxSupply: 2587,
      cid: "bafkreifuduvzmcc5ozkdnbazvgbspu46cam5me35cqh37np4qud3w5jhzu",
    },
    {
      finish: "Serialized",
      name: "The Moai",
      catalogId: "SE040",
      onchainEditionId: 279,
      maxSupply: 50,
      cid: null,
    },
  ],
  "041": [
    {
      finish: "Base",
      name: "Late Nightcap",
      catalogId: "041",
      onchainEditionId: 40,
      maxSupply: 13906,
      cid: "bafkreigz5yd3hi7dkm5q5fkylsfvfebrlalggztf5oopr4tu23fw4z4yt4",
    },
    {
      finish: "Foil",
      name: "Late Nightcap",
      catalogId: "F041",
      onchainEditionId: 160,
      maxSupply: 1493,
      cid: "bafkreigswswgikn3iqklmmhd2p75eqpaha5xqq7zshpltouswn2v4vkzs4",
    },
    {
      finish: "Serialized",
      name: "Late Nightcap",
      catalogId: "SE041",
      onchainEditionId: 280,
      maxSupply: 10,
      cid: null,
    },
  ],
  "042": [
    {
      finish: "Base",
      name: "Lion Dance",
      catalogId: "042",
      onchainEditionId: 41,
      maxSupply: 13906,
      cid: "bafkreihjx6v6alxd4ruwngb3prpqsroyikawvlscpcxcz4whg56svysy7a",
    },
    {
      finish: "Foil",
      name: "Lion Dance",
      catalogId: "F042",
      onchainEditionId: 161,
      maxSupply: 1493,
      cid: "bafkreiaugu2jp7f7tyexyjj25patqnccbeealydmmagu3bcsry6gesxadi",
    },
    {
      finish: "Serialized",
      name: "Lion Dance",
      catalogId: "SE042",
      onchainEditionId: 281,
      maxSupply: 10,
      cid: null,
    },
  ],
  "043": [
    {
      finish: "Base",
      name: "Sick Day",
      catalogId: "043",
      onchainEditionId: 42,
      maxSupply: 21878,
      cid: "bafkreifk3xkivunltippx5gdw3e5okyhkltf32ekqfqy3nekvi7buzsw5e",
    },
    {
      finish: "Foil",
      name: "Sick Day",
      catalogId: "F043",
      onchainEditionId: 162,
      maxSupply: 2352,
      cid: "bafkreidooukedlwbyq5lhw6raqq2xlz3ajf2uymb7btjckzqdwmpt6qqze",
    },
    {
      finish: "Serialized",
      name: "Sick Day",
      catalogId: "SE043",
      onchainEditionId: 282,
      maxSupply: 99,
      cid: null,
    },
  ],
  "044": [
    {
      finish: "Base",
      name: "Bored Monday",
      catalogId: "044",
      onchainEditionId: 43,
      maxSupply: 21878,
      cid: "bafkreia3gnaucp2towgswd7dr6v2dp7jwq527n5xb226le2hbm24mm2tgm",
    },
    {
      finish: "Foil",
      name: "Bored Monday",
      catalogId: "F044",
      onchainEditionId: 163,
      maxSupply: 2352,
      cid: "bafkreihkyuzn5xdp7k3ftve63yxpoj4xqumee36xosaduutnjpf53aityy",
    },
    {
      finish: "Serialized",
      name: "Bored Monday",
      catalogId: "SE044",
      onchainEditionId: 283,
      maxSupply: 99,
      cid: null,
    },
  ],
  "045": [
    {
      finish: "Base",
      name: "Dead to the World",
      catalogId: "045",
      onchainEditionId: 44,
      maxSupply: 24060,
      cid: "bafkreicbvtk36wwdi4lqw3fd7t6rvlfpcldwow4qq5g3rcqldquz4ue56u",
    },
    {
      finish: "Foil",
      name: "Dead to the World",
      catalogId: "F045",
      onchainEditionId: 164,
      maxSupply: 2587,
      cid: "bafkreigeinzq367qmw7qemeoo232tazllptegfou7fy3w6wdkaqk4du4sa",
    },
    {
      finish: "Serialized",
      name: "Dead to the World",
      catalogId: "SE045",
      onchainEditionId: 284,
      maxSupply: 50,
      cid: null,
    },
  ],
  "046": [
    {
      finish: "Base",
      name: "Field Day",
      catalogId: "046",
      onchainEditionId: 45,
      maxSupply: 21878,
      cid: "bafkreibsbwusqnxej3mundok6x42mlfdu3upyqwoxu5zvrhk7xhrab4vji",
    },
    {
      finish: "Foil",
      name: "Field Day",
      catalogId: "F046",
      onchainEditionId: 165,
      maxSupply: 2352,
      cid: "bafkreifc6ahftnfjql6zbg3dn3i6bllkkphuc6znx6bbifmuj7eluin3eq",
    },
    {
      finish: "Serialized",
      name: "Field Day",
      catalogId: "SE046",
      onchainEditionId: 285,
      maxSupply: 99,
      cid: null,
    },
  ],
  "047": [
    {
      finish: "Base",
      name: "The Fridge",
      catalogId: "047",
      onchainEditionId: 46,
      maxSupply: 24060,
      cid: "bafkreihycahqvmdwi5n5zo4oyog7kon267jd2eudwiqgumhogbx7cxrgie",
    },
    {
      finish: "Foil",
      name: "The Fridge",
      catalogId: "F047",
      onchainEditionId: 166,
      maxSupply: 2587,
      cid: "bafkreidrv5ctw4xqsuvnhnoxubwqbl63hdsgfqznxu5b2i6pvmrplyqple",
    },
    {
      finish: "Serialized",
      name: "The Fridge",
      catalogId: "SE047",
      onchainEditionId: 286,
      maxSupply: 50,
      cid: null,
    },
  ],
  "048": [
    {
      finish: "Base",
      name: "Detention",
      catalogId: "048",
      onchainEditionId: 47,
      maxSupply: 21878,
      cid: "bafkreic3zgwownr5434jto3sjqcnbskfjfsuyefgrlkt4zdx5beftwkrdy",
    },
    {
      finish: "Foil",
      name: "Detention",
      catalogId: "F048",
      onchainEditionId: 167,
      maxSupply: 2352,
      cid: "bafkreianbg3md5dosmllvfng7ae3t73fhgvywqsjdd3oeqtvdht7xjyaru",
    },
    {
      finish: "Serialized",
      name: "Detention",
      catalogId: "SE048",
      onchainEditionId: 287,
      maxSupply: 99,
      cid: null,
    },
  ],
  "049": [
    {
      finish: "Base",
      name: "Good Boy Gary",
      catalogId: "049",
      onchainEditionId: 48,
      maxSupply: 1320,
      cid: "bafkreiej3wqyw5lts4kl2sxzqpmieg2oiqecgn4joqbbb75encaxehfrva",
    },
    {
      finish: "Foil",
      name: "Good Boy Gary",
      catalogId: "F049",
      onchainEditionId: 168,
      maxSupply: 136,
      cid: "bafkreiahlbofkoj3lxe7ou2iwh4bdkrplponj764mqtbs2lk36xb45cqyu",
    },
    {
      finish: "Serialized",
      name: "Good Boy Gary",
      catalogId: "SE049",
      onchainEditionId: 288,
      maxSupply: 1,
      cid: "bafkreiewiakzqryd6jr5v6yzdsc25s7tivys5vfz5x42q2y3rkycjjk3ym",
    },
  ],
  "050": [
    {
      finish: "Base",
      name: "The Morning After",
      catalogId: "050",
      onchainEditionId: 49,
      maxSupply: 21878,
      cid: "bafkreiavg2jku4gf7y3ll6t2rko4voj2lb46nbaxnlvxb6sw3mhvcna2pa",
    },
    {
      finish: "Foil",
      name: "The Morning After",
      catalogId: "F050",
      onchainEditionId: 169,
      maxSupply: 2352,
      cid: "bafkreichwnwbz3p7n3z7gxknwfl2gvtujzb2olv2hwqjsi2ctuihc5hwni",
    },
    {
      finish: "Serialized",
      name: "The Morning After",
      catalogId: "SE050",
      onchainEditionId: 289,
      maxSupply: 99,
      cid: null,
    },
  ],
  "051": [
    {
      finish: "Base",
      name: "Happy Holidays",
      catalogId: "051",
      onchainEditionId: 50,
      maxSupply: 24060,
      cid: "bafkreibma3vsqzz3eiq2qy5n5ek4ynmgvxbpw43lmrxvnprsqlkn75sv24",
    },
    {
      finish: "Foil",
      name: "Happy Holidays",
      catalogId: "F051",
      onchainEditionId: 170,
      maxSupply: 2587,
      cid: "bafkreiewb6lv6hz7fgjnjkwcfn2xcfz7agsyegkuk5gymeysj74hkj2qrm",
    },
    {
      finish: "Serialized",
      name: "Happy Holidays",
      catalogId: "SE051",
      onchainEditionId: 290,
      maxSupply: 50,
      cid: null,
    },
  ],
  "052": [
    {
      finish: "Base",
      name: "The Long Weekend",
      catalogId: "052",
      onchainEditionId: 51,
      maxSupply: 24060,
      cid: "bafkreihxy66avfla4x7ffhhfvb7rqpwsgaokh57fvwkuoxpe3skkcth3gq",
    },
    {
      finish: "Foil",
      name: "The Long Weekend",
      catalogId: "F052",
      onchainEditionId: 171,
      maxSupply: 2587,
      cid: "bafkreiehoocq2ozxscaad3cwbq7rhkpgrksgqi5rnk6ectoqxm3omju5wi",
    },
    {
      finish: "Serialized",
      name: "The Long Weekend",
      catalogId: "SE052",
      onchainEditionId: 291,
      maxSupply: 50,
      cid: null,
    },
  ],
  "053": [
    {
      finish: "Base",
      name: "Sofa Shark",
      catalogId: "053",
      onchainEditionId: 52,
      maxSupply: 13906,
      cid: "bafkreidfxaoeoa3acgurmy5ftq4m6dzdzqtdxanrmf2s5qe3zkn2fqfgta",
    },
    {
      finish: "Foil",
      name: "Sofa Shark",
      catalogId: "F053",
      onchainEditionId: 172,
      maxSupply: 1493,
      cid: "bafkreihmokliujuzdl7yqxvfovtjknista7zkmyxk5cj33dh4gj6whylku",
    },
    {
      finish: "Serialized",
      name: "Sofa Shark",
      catalogId: "SE053",
      onchainEditionId: 292,
      maxSupply: 10,
      cid: null,
    },
  ],
  "054": [
    {
      finish: "Base",
      name: "Never Alone",
      catalogId: "054",
      onchainEditionId: 53,
      maxSupply: 21878,
      cid: "bafkreidnih3udp6vglwvjz463jbmuiosknre6co7kiojpi7gbtgelmyr6i",
    },
    {
      finish: "Foil",
      name: "Never Alone",
      catalogId: "F054",
      onchainEditionId: 173,
      maxSupply: 2352,
      cid: "bafkreih4lg7isj7vf5ave6zs4mnf43lf5occ4qk5gexclunjqlzyvrg7kq",
    },
    {
      finish: "Serialized",
      name: "Never Alone",
      catalogId: "SE054",
      onchainEditionId: 293,
      maxSupply: 99,
      cid: null,
    },
  ],
  "055": [
    {
      finish: "Base",
      name: "Shelf Life",
      catalogId: "055",
      onchainEditionId: 54,
      maxSupply: 21878,
      cid: "bafkreida6nxvqfrnxq3dhwdlvx3tvaloh77cy4w7suxgjcqmwma7d54ddm",
    },
    {
      finish: "Foil",
      name: "Shelf Life",
      catalogId: "F055",
      onchainEditionId: 174,
      maxSupply: 2352,
      cid: "bafkreicblkewz3lt5bd4mllsiqjgxcohuewdqligr5h7fsjzyvmghqzlim",
    },
    {
      finish: "Serialized",
      name: "Shelf Life",
      catalogId: "SE055",
      onchainEditionId: 294,
      maxSupply: 99,
      cid: null,
    },
  ],
  "056": [
    {
      finish: "Base",
      name: "A Cult Classic",
      catalogId: "056",
      onchainEditionId: 55,
      maxSupply: 21878,
      cid: "bafkreig6mfjbzvxutm6gknpv4y6ok2viqenrqfcqyhremur4t7pern2pr4",
    },
    {
      finish: "Foil",
      name: "A Cult Classic",
      catalogId: "F056",
      onchainEditionId: 175,
      maxSupply: 2352,
      cid: "bafkreiapje2l4j7tt5bhgwfsyd5rc4xmsqgvscrbdr4ntqmowbmnr2f7nu",
    },
    {
      finish: "Serialized",
      name: "A Cult Classic",
      catalogId: "SE056",
      onchainEditionId: 295,
      maxSupply: 99,
      cid: null,
    },
  ],
  "057": [
    {
      finish: "Base",
      name: "Packed in Oil",
      catalogId: "057",
      onchainEditionId: 56,
      maxSupply: 21878,
      cid: "bafkreigu6vdshtpo33dbvwhbkmflmxg4wbdfjdoj5cdssea4nqpcnoqufe",
    },
    {
      finish: "Foil",
      name: "Packed in Oil",
      catalogId: "F057",
      onchainEditionId: 176,
      maxSupply: 2352,
      cid: "bafkreiazszzhild5eq42zjebjpndsafmzrtje5b5iz2epzgtciuqnvjpxm",
    },
    {
      finish: "Serialized",
      name: "Packed in Oil",
      catalogId: "SE057",
      onchainEditionId: 296,
      maxSupply: 99,
      cid: null,
    },
  ],
  "058": [
    {
      finish: "Base",
      name: "Extra Salty",
      catalogId: "058",
      onchainEditionId: 57,
      maxSupply: 21878,
      cid: "bafkreibjihmcuswxym3pnsrhu5pwbhe2j62yuzvln3npsn2ekc3kexgz2y",
    },
    {
      finish: "Foil",
      name: "Extra Salty",
      catalogId: "F058",
      onchainEditionId: 177,
      maxSupply: 2352,
      cid: "bafkreiehvbnao4mtylr6siq6jpd3kyevnodge7iwrg4e33r2kgns75ipau",
    },
    {
      finish: "Serialized",
      name: "Extra Salty",
      catalogId: "SE058",
      onchainEditionId: 297,
      maxSupply: 99,
      cid: null,
    },
  ],
  "059": [
    {
      finish: "Base",
      name: "Fresh Cut",
      catalogId: "059",
      onchainEditionId: 58,
      maxSupply: 3626,
      cid: "bafkreigrcri34qt2kvfafo5b5eubv7qazi5h5bnwnn7p2s2ft4hcqc2zry",
    },
    {
      finish: "Foil",
      name: "Fresh Cut",
      catalogId: "F059",
      onchainEditionId: 178,
      maxSupply: 384,
      cid: "bafkreib6oywkhpog6kavuh2ta2z7m2da6wj6asqp5lz52o6xfcpodmwswa",
    },
    {
      finish: "Serialized",
      name: "Fresh Cut",
      catalogId: "SE059",
      onchainEditionId: 298,
      maxSupply: 5,
      cid: "bafkreihmcp4ziifv3c5ebickg5crbxfpw6p27bbhzrbznpsif6ykavyj2y",
    },
  ],
  "060": [
    {
      finish: "Base",
      name: "Elevator Ride",
      catalogId: "060",
      onchainEditionId: 59,
      maxSupply: 3626,
      cid: "bafkreic6ht4ijckiey6i6fjqp2bve5degkhsjnnypfyykc4iu3lbuwqwde",
    },
    {
      finish: "Foil",
      name: "Elevator Ride",
      catalogId: "F060",
      onchainEditionId: 179,
      maxSupply: 384,
      cid: "bafkreih3uwucpscmgrihttruq4iqfrngpl7opwnegwalwfdwzv5dgsoscm",
    },
    {
      finish: "Serialized",
      name: "Elevator Ride",
      catalogId: "SE060",
      onchainEditionId: 299,
      maxSupply: 5,
      cid: "bafkreicutfcrwgjtfubt6l5go2c4frhsarceqc67qavqxgjsvesybv25n4",
    },
  ],
  "061": [
    {
      finish: "Base",
      name: "The Lowrider",
      catalogId: "061",
      onchainEditionId: 60,
      maxSupply: 3626,
      cid: "bafkreibeyptrcbgxf26jv2oiww5xsiraizoygjj5purx2rhcqfchcojjlq",
    },
    {
      finish: "Foil",
      name: "The Lowrider",
      catalogId: "F061",
      onchainEditionId: 180,
      maxSupply: 384,
      cid: "bafkreihzdpjc5morbndoanxnyhz7553kouravef2mznd3ca6qcgvtm7lle",
    },
    {
      finish: "Serialized",
      name: "The Lowrider",
      catalogId: "SE061",
      onchainEditionId: 300,
      maxSupply: 5,
      cid: "bafkreidw4sl76okm4do6bsz6i6ngs2fmyno2r7lst4clwma3onjzeurwgi",
    },
  ],
  "062": [
    {
      finish: "Base",
      name: "The Founder",
      catalogId: "062",
      onchainEditionId: 61,
      maxSupply: 1320,
      cid: "bafkreid2o23invpuy25otljzaqhgvxoo3ce64u2cf25ircg4dwrantgoka",
    },
    {
      finish: "Foil",
      name: "The Founder",
      catalogId: "F062",
      onchainEditionId: 181,
      maxSupply: 136,
      cid: "bafkreiajyw74dpotiwdj6sjpjw4mm2irm4bbtaxlowyzvjz74jd6ugehoy",
    },
    {
      finish: "Serialized",
      name: "The Founder",
      catalogId: "SE062",
      onchainEditionId: 301,
      maxSupply: 1,
      cid: "bafkreihqmepnvc3enbr6j2bch6sfih7zcocx7jqx37yodnxc6ad7ye42gm",
    },
  ],
  "063": [
    {
      finish: "Base",
      name: "Serum I",
      catalogId: "063",
      onchainEditionId: 62,
      maxSupply: 21878,
      cid: "bafkreibwum54i7yiremhs33ubffcjxxinreqn4eooalrm4pykbv5bqnrum",
    },
    {
      finish: "Foil",
      name: "Serum I",
      catalogId: "F063",
      onchainEditionId: 182,
      maxSupply: 2352,
      cid: "bafkreicezys75lso65e7n7hg46jhetxf7dfab7my5e55c5pou7legcc7ja",
    },
    {
      finish: "Serialized",
      name: "Serum I",
      catalogId: "SE063",
      onchainEditionId: 302,
      maxSupply: 99,
      cid: null,
    },
  ],
  "064": [
    {
      finish: "Base",
      name: "Serum II",
      catalogId: "064",
      onchainEditionId: 63,
      maxSupply: 21878,
      cid: "bafkreifr4cadn4hvzccpnwwmpw2i6ntacuz65qkzi6ghxzkf6g4y4ynf5a",
    },
    {
      finish: "Foil",
      name: "Serum II",
      catalogId: "F064",
      onchainEditionId: 183,
      maxSupply: 2352,
      cid: "bafkreibywypmoqatvhc7wdxp2ro3aknsp7oolothyt4hv63ubz7nqdkoey",
    },
    {
      finish: "Serialized",
      name: "Serum II",
      catalogId: "SE064",
      onchainEditionId: 303,
      maxSupply: 99,
      cid: null,
    },
  ],
  "065": [
    {
      finish: "Base",
      name: "Serum Molt",
      catalogId: "065",
      onchainEditionId: 64,
      maxSupply: 21878,
      cid: "bafkreicwlbmibtveh2f4q3kw2kgsrgk3uays54qirrvautzimq7m6o4h2a",
    },
    {
      finish: "Foil",
      name: "Serum Molt",
      catalogId: "F065",
      onchainEditionId: 184,
      maxSupply: 2352,
      cid: "bafkreib3ahrkujao4grmy6u26m2a7v734tifurqrtrlcgjgtpktcwixhne",
    },
    {
      finish: "Serialized",
      name: "Serum Molt",
      catalogId: "SE065",
      onchainEditionId: 304,
      maxSupply: 99,
      cid: null,
    },
  ],
  "066": [
    {
      finish: "Base",
      name: "Serum III",
      catalogId: "066",
      onchainEditionId: 65,
      maxSupply: 24060,
      cid: "bafkreigo4wntjmqsxy3t3moscun4mwwugzdy3cfjyeyq3jwwkgxh4w5d2m",
    },
    {
      finish: "Foil",
      name: "Serum III",
      catalogId: "F066",
      onchainEditionId: 185,
      maxSupply: 2587,
      cid: "bafkreidsbpded23xz227m7p6rz46ylcmtv34id52rjukmrvzoivuvg6nmi",
    },
    {
      finish: "Serialized",
      name: "Serum III",
      catalogId: "SE066",
      onchainEditionId: 305,
      maxSupply: 50,
      cid: null,
    },
  ],
  "067": [
    {
      finish: "Base",
      name: "The Mercury Ape",
      catalogId: "067",
      onchainEditionId: 66,
      maxSupply: 13906,
      cid: "bafkreigoc5vtovm3ouh6jolyhplp4iugwu57yeawixcf6y4lw3dem7gtkq",
    },
    {
      finish: "Foil",
      name: "The Mercury Ape",
      catalogId: "F067",
      onchainEditionId: 186,
      maxSupply: 1493,
      cid: "bafkreigoruhv2memyitaueh43e5hlanglnrfhgnk2536yqk5cpseibc2ty",
    },
    {
      finish: "Serialized",
      name: "The Mercury Ape",
      catalogId: "SE067",
      onchainEditionId: 306,
      maxSupply: 10,
      cid: null,
    },
  ],
  "068": [
    {
      finish: "Base",
      name: "The Gurgle",
      catalogId: "068",
      onchainEditionId: 67,
      maxSupply: 21878,
      cid: "bafkreiciurz3guqhf6bs6bxhcgkinpud7kwhe7gkw6gag65vmt7w5vjodu",
    },
    {
      finish: "Foil",
      name: "The Gurgle",
      catalogId: "F068",
      onchainEditionId: 187,
      maxSupply: 2352,
      cid: "bafkreigbsmugtlo22gleolw37f62pg47pem4pkjqvz6zfhcvpbe3kpxqba",
    },
    {
      finish: "Serialized",
      name: "The Gurgle",
      catalogId: "SE068",
      onchainEditionId: 307,
      maxSupply: 99,
      cid: null,
    },
  ],
  "069": [
    {
      finish: "Base",
      name: "The Flush",
      catalogId: "069",
      onchainEditionId: 68,
      maxSupply: 21878,
      cid: "bafkreigfwjsztbsrmp34r6oijoxqey7o5wb266p2egzt34gmco2wtefs64",
    },
    {
      finish: "Foil",
      name: "The Flush",
      catalogId: "F069",
      onchainEditionId: 188,
      maxSupply: 2352,
      cid: "bafkreicf6a2ycbw2lzzlgzcikzp26tqh646xezntgyl6qyzssh2khmgnxy",
    },
    {
      finish: "Serialized",
      name: "The Flush",
      catalogId: "SE069",
      onchainEditionId: 308,
      maxSupply: 99,
      cid: null,
    },
  ],
  "070": [
    {
      finish: "Base",
      name: "The Golden Plunger",
      catalogId: "070",
      onchainEditionId: 69,
      maxSupply: 21878,
      cid: "bafkreickrxg4a3yf3dhxhrykhkp6wged4rcaqjn5wvh4w43h2zbta7ngkq",
    },
    {
      finish: "Foil",
      name: "The Golden Plunger",
      catalogId: "F070",
      onchainEditionId: 189,
      maxSupply: 2352,
      cid: "bafkreiaiyr73mtl5ekpld3t2bw3qsm2daflb7nhzdgwbhmotoziosy776y",
    },
    {
      finish: "Serialized",
      name: "The Golden Plunger",
      catalogId: "SE070",
      onchainEditionId: 309,
      maxSupply: 99,
      cid: null,
    },
  ],
  "071": [
    {
      finish: "Base",
      name: "The Split",
      catalogId: "071",
      onchainEditionId: 70,
      maxSupply: 24060,
      cid: "bafkreibhtdr4dnkgjkb7vvtt2llt6i5rnh6up2q6qwc2mec2vbb6xbonly",
    },
    {
      finish: "Foil",
      name: "The Split",
      catalogId: "F071",
      onchainEditionId: 190,
      maxSupply: 2587,
      cid: "bafkreichfehip6bkujejj6g3wjtetzvws3utobl6ql4uahafmrre5fp2k4",
    },
    {
      finish: "Serialized",
      name: "The Split",
      catalogId: "SE071",
      onchainEditionId: 310,
      maxSupply: 50,
      cid: null,
    },
  ],
  "072": [
    {
      finish: "Base",
      name: "Skeleton Key",
      catalogId: "072",
      onchainEditionId: 71,
      maxSupply: 3626,
      cid: "bafkreidh2jyodzm6qqdyaj5jsae7e5cuc5dhn5nwhbduayytzrfhoekj7a",
    },
    {
      finish: "Foil",
      name: "Skeleton Key",
      catalogId: "F072",
      onchainEditionId: 191,
      maxSupply: 384,
      cid: "bafkreiff4nonhhhufudcemac276quap53csfdcoueslzcbjfywyqhk7gku",
    },
    {
      finish: "Serialized",
      name: "Skeleton Key",
      catalogId: "SE072",
      onchainEditionId: 311,
      maxSupply: 5,
      cid: "bafkreidam6m6czem6arfdvwql5fnmookqoo275iurj7n4hdvsylyluhcve",
    },
  ],
  "073": [
    {
      finish: "Base",
      name: "The Spare",
      catalogId: "073",
      onchainEditionId: 72,
      maxSupply: 21878,
      cid: "bafkreidczjl3hrvodb7sltemol6tyyv77nclhtbzxcmfashjmutya7eu4m",
    },
    {
      finish: "Foil",
      name: "The Spare",
      catalogId: "F073",
      onchainEditionId: 192,
      maxSupply: 2352,
      cid: "bafkreiggfkhc6j447kinntoidsgc2g7na2tjjdcxr7dkzpd2ubgcde4nwy",
    },
    {
      finish: "Serialized",
      name: "The Spare",
      catalogId: "SE073",
      onchainEditionId: 312,
      maxSupply: 99,
      cid: null,
    },
  ],
  "074": [
    {
      finish: "Base",
      name: "The Throne",
      catalogId: "074",
      onchainEditionId: 73,
      maxSupply: 21878,
      cid: "bafkreifqta3go3grbgadyau5kaf6v6l3qohgymdieo6ow5zdt5yptd4syq",
    },
    {
      finish: "Foil",
      name: "The Throne",
      catalogId: "F074",
      onchainEditionId: 193,
      maxSupply: 2352,
      cid: "bafkreigiv75wk52tgjnpk4gm5jcixy7f2euhw4fx3ljiyldpzsc4wbysku",
    },
    {
      finish: "Serialized",
      name: "The Throne",
      catalogId: "SE074",
      onchainEditionId: 313,
      maxSupply: 99,
      cid: null,
    },
  ],
  "075": [
    {
      finish: "Base",
      name: "The Lifesaver",
      catalogId: "075",
      onchainEditionId: 74,
      maxSupply: 21878,
      cid: "bafkreibmgkclcfmk2dmgivdmbxqswdwj6q5ebejmdxzq2vssebrsthvkvy",
    },
    {
      finish: "Foil",
      name: "The Lifesaver",
      catalogId: "F075",
      onchainEditionId: 194,
      maxSupply: 2352,
      cid: "bafkreieqvl7lwnkfcqca7ybb4xcs2ah2wynjrhrxnqbiqlvst2nm54vs7m",
    },
    {
      finish: "Serialized",
      name: "The Lifesaver",
      catalogId: "SE075",
      onchainEditionId: 314,
      maxSupply: 99,
      cid: null,
    },
  ],
  "076": [
    {
      finish: "Base",
      name: "The DDcow",
      catalogId: "076",
      onchainEditionId: 75,
      maxSupply: 13906,
      cid: "bafkreidgiopbbttows2udg5yqdacluezaw2ystmnju5jre4weymq5oum4a",
    },
    {
      finish: "Foil",
      name: "The DDcow",
      catalogId: "F076",
      onchainEditionId: 195,
      maxSupply: 1493,
      cid: "bafkreigapsj73ucmg5goks5xjagmqqo6j6pea2maijfovqkqbd7gmvu5v4",
    },
    {
      finish: "Serialized",
      name: "The DDcow",
      catalogId: "SE076",
      onchainEditionId: 315,
      maxSupply: 10,
      cid: null,
    },
  ],
  "077": [
    {
      finish: "Base",
      name: "Half-Mutated",
      catalogId: "077",
      onchainEditionId: 76,
      maxSupply: 24060,
      cid: "bafkreiar764327sjuguo5jdydlo6t46lfszqmnio5y2jz3goh7jg6hx2f4",
    },
    {
      finish: "Foil",
      name: "Half-Mutated",
      catalogId: "F077",
      onchainEditionId: 196,
      maxSupply: 2587,
      cid: "bafkreiggk3flbbptbsnfrrwq7iexws2djnkjktpsbanhzf3hzeojga723a",
    },
    {
      finish: "Serialized",
      name: "Half-Mutated",
      catalogId: "SE077",
      onchainEditionId: 316,
      maxSupply: 50,
      cid: null,
    },
  ],
  "078": [
    {
      finish: "Base",
      name: "The Divers",
      catalogId: "078",
      onchainEditionId: 77,
      maxSupply: 24060,
      cid: "bafkreigtjezhqkc2cbtoc5ykjd2uftxuluw3u7mmtqbgvweypl4t6vtb5m",
    },
    {
      finish: "Foil",
      name: "The Divers",
      catalogId: "F078",
      onchainEditionId: 197,
      maxSupply: 2587,
      cid: "bafkreiagqyrvixphdusozcktoofn4znbeirhyeh4ltmkhlp3wy6243n5uq",
    },
    {
      finish: "Serialized",
      name: "The Divers",
      catalogId: "SE078",
      onchainEditionId: 317,
      maxSupply: 50,
      cid: null,
    },
  ],
  "079": [
    {
      finish: "Base",
      name: "The Outbreak",
      catalogId: "079",
      onchainEditionId: 78,
      maxSupply: 24060,
      cid: "bafkreieemy3h5dihfcbesyecnzltxidpofjwig3bryzlswlp5nwz2eufe4",
    },
    {
      finish: "Foil",
      name: "The Outbreak",
      catalogId: "F079",
      onchainEditionId: 198,
      maxSupply: 2587,
      cid: "bafkreiczwklcmafnqmorqmbgmcyyc3ougisn56vzbaj577m4njffkpajna",
    },
    {
      finish: "Serialized",
      name: "The Outbreak",
      catalogId: "SE079",
      onchainEditionId: 318,
      maxSupply: 50,
      cid: null,
    },
  ],
  "080": [
    {
      finish: "Base",
      name: "The Runner",
      catalogId: "080",
      onchainEditionId: 79,
      maxSupply: 24060,
      cid: "bafkreibho2mrp6uwbjmxku2ogtunyotfmmwqmxxxp5iamv7btgnkxdntru",
    },
    {
      finish: "Foil",
      name: "The Runner",
      catalogId: "F080",
      onchainEditionId: 199,
      maxSupply: 2587,
      cid: "bafkreifhey3l7zq4a7o3tbk5o4enyqr6wdup4kjimntqery3kl2vbqqlka",
    },
    {
      finish: "Serialized",
      name: "The Runner",
      catalogId: "SE080",
      onchainEditionId: 319,
      maxSupply: 50,
      cid: null,
    },
  ],
  "081": [
    {
      finish: "Base",
      name: "Sewer Hoard",
      catalogId: "081",
      onchainEditionId: 80,
      maxSupply: 3626,
      cid: "bafkreiflxncppfhdurlqmpfpdj5oqkymqgjx2lgnfsmqtl5glkkwfyg35y",
    },
    {
      finish: "Foil",
      name: "Sewer Hoard",
      catalogId: "F081",
      onchainEditionId: 200,
      maxSupply: 384,
      cid: "bafkreidbe5ze4ysc5e5wjtkf23mgilwthnf6fm2mkpq3pvcp6z3nehmeh4",
    },
    {
      finish: "Serialized",
      name: "Sewer Hoard",
      catalogId: "SE081",
      onchainEditionId: 320,
      maxSupply: 5,
      cid: "bafkreibzukptq2tcsunlgdnn3z3eekxrhi3pn4wfodfkof7f4sknm5sxam",
    },
  ],
  "082": [
    {
      finish: "Base",
      name: "Neon Cowboy",
      catalogId: "082",
      onchainEditionId: 81,
      maxSupply: 3626,
      cid: "bafkreicbmfg42hemcknar25ib23mfvessq5sbgiu77lt7a2bjq6d4csmly",
    },
    {
      finish: "Foil",
      name: "Neon Cowboy",
      catalogId: "F082",
      onchainEditionId: 201,
      maxSupply: 384,
      cid: "bafkreicrh7xdzvsh3m7pawi4xl3czy3ihxmgkujl6vscllsq7qbsgdtpfa",
    },
    {
      finish: "Serialized",
      name: "Neon Cowboy",
      catalogId: "SE082",
      onchainEditionId: 321,
      maxSupply: 5,
      cid: "bafkreib2ecjaon4k5fqisxrfwtgjxem4ckdudte3ogk775fkb3jxq3x2fm",
    },
  ],
  "083": [
    {
      finish: "Base",
      name: "The Portal",
      catalogId: "083",
      onchainEditionId: 82,
      maxSupply: 1320,
      cid: "bafkreicvlfvbkj53xqk6tsufa36ic76r7zyxenhvt7nhsrs3c5sh4ylsk4",
    },
    {
      finish: "Foil",
      name: "The Portal",
      catalogId: "F083",
      onchainEditionId: 202,
      maxSupply: 136,
      cid: "bafkreia4wqsydvsr6wyili45bbs567c2t6xd7oddmzp3lkncqjyl7o5ehe",
    },
    {
      finish: "Serialized",
      name: "The Portal",
      catalogId: "SE083",
      onchainEditionId: 322,
      maxSupply: 1,
      cid: "bafkreieeuihanfoadspysrvb56f34pv4zgyqaa4qxfkrc5hwvt6xg7rqum",
    },
  ],
  "084": [
    {
      finish: "Base",
      name: "The Box",
      catalogId: "084",
      onchainEditionId: 83,
      maxSupply: 1320,
      cid: "bafkreiesb6au3o2363wjm2pzonn27icr6uyvsg7bsmqgewxq55zy36r24q",
    },
    {
      finish: "Foil",
      name: "The Box",
      catalogId: "F084",
      onchainEditionId: 203,
      maxSupply: 136,
      cid: "bafkreibumg3ew7tufjmr6zh6lws33rbdwm4jwyuwrsiagatfxdk552wdzq",
    },
    {
      finish: "Serialized",
      name: "The Box",
      catalogId: "SE084",
      onchainEditionId: 323,
      maxSupply: 1,
      cid: "bafkreidreqb7hd5ue2ykqrw4az57g7vtcfdgbveofslg7h5tqwfh474e3y",
    },
  ],
  "085": [
    {
      finish: "Base",
      name: "The Pulsar",
      catalogId: "085",
      onchainEditionId: 84,
      maxSupply: 13906,
      cid: "bafkreieyqj5g6mvmzssiyvivnx3fognkrrv4nljx5hjyttlnqtrf2pg22a",
    },
    {
      finish: "Foil",
      name: "The Pulsar",
      catalogId: "F085",
      onchainEditionId: 204,
      maxSupply: 1493,
      cid: "bafkreibechf5hmdw6wiiui7qw2wha5ftv6nxzunfx3bigb54hqst2yw5jq",
    },
    {
      finish: "Serialized",
      name: "The Pulsar",
      catalogId: "SE085",
      onchainEditionId: 324,
      maxSupply: 10,
      cid: null,
    },
  ],
  "086": [
    {
      finish: "Base",
      name: "The Convergence",
      catalogId: "086",
      onchainEditionId: 85,
      maxSupply: 13905,
      cid: "bafkreibrz3hpc5y323h2eh7laecfxtir3qiosiz5xlyla6gzzbsovdfjpa",
    },
    {
      finish: "Foil",
      name: "The Convergence",
      catalogId: "F086",
      onchainEditionId: 205,
      maxSupply: 1493,
      cid: "bafkreidq4bcbqzym5d7psz2vqqiazi7s5u7uyshuzyrjakd3qtih3hta5m",
    },
    {
      finish: "Serialized",
      name: "The Convergence",
      catalogId: "SE086",
      onchainEditionId: 325,
      maxSupply: 10,
      cid: null,
    },
  ],
  "087": [
    {
      finish: "Base",
      name: "The Nova",
      catalogId: "087",
      onchainEditionId: 86,
      maxSupply: 13905,
      cid: "bafkreiflyd3xxi6if6wlvsutuem7z6h4bkrfsbjfw37ra4vwj36cppgnri",
    },
    {
      finish: "Foil",
      name: "The Nova",
      catalogId: "F087",
      onchainEditionId: 206,
      maxSupply: 1493,
      cid: "bafkreief55tft3iskdfmqnzna4sqwuaotwrpijlcakxniho32z5bkanxbq",
    },
    {
      finish: "Serialized",
      name: "The Nova",
      catalogId: "SE087",
      onchainEditionId: 326,
      maxSupply: 10,
      cid: null,
    },
  ],
  "088": [
    {
      finish: "Base",
      name: "The Zenith",
      catalogId: "088",
      onchainEditionId: 87,
      maxSupply: 13905,
      cid: "bafkreiems5f2eivcf7ep2fqjovnr4eet46iy3el2qlzb5zyf6ggcnqy2fi",
    },
    {
      finish: "Foil",
      name: "The Zenith",
      catalogId: "F088",
      onchainEditionId: 207,
      maxSupply: 1493,
      cid: "bafkreidmij33as7tq5fh635gp52axsfawqitjvkrhknnwo2relkil4wlxu",
    },
    {
      finish: "Serialized",
      name: "The Zenith",
      catalogId: "SE088",
      onchainEditionId: 327,
      maxSupply: 10,
      cid: null,
    },
  ],
  "089": [
    {
      finish: "Base",
      name: "The Eternal",
      catalogId: "089",
      onchainEditionId: 88,
      maxSupply: 13905,
      cid: "bafkreidm3n4tbjmahw5q77d7wxst4y56d55iirv5cnlrp3lltui5esn25y",
    },
    {
      finish: "Foil",
      name: "The Eternal",
      catalogId: "F089",
      onchainEditionId: 208,
      maxSupply: 1493,
      cid: "bafkreie432h3isnd5reulxmah5xizynfdfw6wa5c6bqfuudfy4cg6i6ff4",
    },
    {
      finish: "Serialized",
      name: "The Eternal",
      catalogId: "SE089",
      onchainEditionId: 328,
      maxSupply: 10,
      cid: null,
    },
  ],
  "090": [
    {
      finish: "Base",
      name: "The Oracle",
      catalogId: "090",
      onchainEditionId: 89,
      maxSupply: 1319,
      cid: "bafkreiett6s4opykwi5wnpqqjwe3jwzahfifdch4njhejfvr3n3r2uxqhy",
    },
    {
      finish: "Foil",
      name: "The Oracle",
      catalogId: "F090",
      onchainEditionId: 209,
      maxSupply: 136,
      cid: "bafkreigsivruyx3hzrwpgg55an2ppoaxdlyhsznjno4bz2uyp3g4q7gjgq",
    },
    {
      finish: "Serialized",
      name: "The Oracle",
      catalogId: "SE090",
      onchainEditionId: 329,
      maxSupply: 1,
      cid: "bafkreids3bzsboasz26xhwlb5g7bgypbubmfq55bq7srvgh4qqosgql5qe",
    },
  ],
  "091": [
    {
      finish: "Base",
      name: "The Abduction",
      catalogId: "091",
      onchainEditionId: 90,
      maxSupply: 21877,
      cid: "bafkreiggyuib4xvibwjhnfpr7ggzwnpp5seqov77gtj3ra7b75pd6tjq4e",
    },
    {
      finish: "Foil",
      name: "The Abduction",
      catalogId: "F091",
      onchainEditionId: 210,
      maxSupply: 2352,
      cid: "bafkreid6xvdtdoncs2ryzl7ltajtuhqgm3hw4pqxxg3sljz5726vkdilg4",
    },
    {
      finish: "Serialized",
      name: "The Abduction",
      catalogId: "SE091",
      onchainEditionId: 330,
      maxSupply: 99,
      cid: null,
    },
  ],
  "092": [
    {
      finish: "Base",
      name: "The Signal",
      catalogId: "092",
      onchainEditionId: 91,
      maxSupply: 24059,
      cid: "bafkreicj4zdqa54qsog7jkgixncvjyoirz7khi6ztu2gr7bpeq2czw7d44",
    },
    {
      finish: "Foil",
      name: "The Signal",
      catalogId: "F092",
      onchainEditionId: 211,
      maxSupply: 2587,
      cid: "bafkreibbutf55oplhateqv4ey6uzmv3wi5csoo6e3l7qomucjduu5g2ooa",
    },
    {
      finish: "Serialized",
      name: "The Signal",
      catalogId: "SE092",
      onchainEditionId: 331,
      maxSupply: 50,
      cid: null,
    },
  ],
  "093": [
    {
      finish: "Base",
      name: "I Want To Believe",
      catalogId: "093",
      onchainEditionId: 92,
      maxSupply: 24059,
      cid: "bafkreiennsxqie5tlyujpfv3oo47xdtcb4ro23dbixiipqijovyio4yfhu",
    },
    {
      finish: "Foil",
      name: "I Want To Believe",
      catalogId: "F093",
      onchainEditionId: 212,
      maxSupply: 2587,
      cid: "bafkreibfqbcekxaihzp47sd3z6ubidbemtgpccatrintamiiwsp633bbnm",
    },
    {
      finish: "Serialized",
      name: "I Want To Believe",
      catalogId: "SE093",
      onchainEditionId: 332,
      maxSupply: 50,
      cid: null,
    },
  ],
  "094": [
    {
      finish: "Base",
      name: "The Hum",
      catalogId: "094",
      onchainEditionId: 93,
      maxSupply: 21877,
      cid: "bafkreihqzkb2u57yh4hh5mxwgaxn3vwswudqkyoqyyj6hjne66cdhjli74",
    },
    {
      finish: "Foil",
      name: "The Hum",
      catalogId: "F094",
      onchainEditionId: 213,
      maxSupply: 2352,
      cid: "bafkreibu2yzss4mxv4pvcy4xpwyuwn6aa4h5hfpzpdcam6on6udz6ru2au",
    },
    {
      finish: "Serialized",
      name: "The Hum",
      catalogId: "SE094",
      onchainEditionId: 333,
      maxSupply: 99,
      cid: null,
    },
  ],
  "095": [
    {
      finish: "Base",
      name: "Moon Dust",
      catalogId: "095",
      onchainEditionId: 94,
      maxSupply: 21877,
      cid: "bafkreihvmh3dk5ie47agch2ebqcyfvtbat4ydznsb5ikfcovlx4fs3pwby",
    },
    {
      finish: "Foil",
      name: "Moon Dust",
      catalogId: "F095",
      onchainEditionId: 214,
      maxSupply: 2352,
      cid: "bafkreiemc42i3clfr72vg2teeb4oyp5cwc5qcp3ziyiboeiwhpjgisazxu",
    },
    {
      finish: "Serialized",
      name: "Moon Dust",
      catalogId: "SE095",
      onchainEditionId: 334,
      maxSupply: 99,
      cid: null,
    },
  ],
  "096": [
    {
      finish: "Base",
      name: "The Watcher",
      catalogId: "096",
      onchainEditionId: 95,
      maxSupply: 21877,
      cid: "bafkreibuflf2d7aa4ebxliafymxsly7624psxjtydefnj43rb7irwsxnbq",
    },
    {
      finish: "Foil",
      name: "The Watcher",
      catalogId: "F096",
      onchainEditionId: 215,
      maxSupply: 2352,
      cid: "bafkreigvma4xat2s5uxtaxfh55no3l7yvk4d4o4lp7akbrm6tzss23gz4a",
    },
    {
      finish: "Serialized",
      name: "The Watcher",
      catalogId: "SE096",
      onchainEditionId: 335,
      maxSupply: 99,
      cid: null,
    },
  ],
  "097": [
    {
      finish: "Base",
      name: "Static",
      catalogId: "097",
      onchainEditionId: 96,
      maxSupply: 21877,
      cid: "bafkreibsz677kxwm3r7uokg7jiukkfv3vhd6kranf7wso4c7wdho5j4mty",
    },
    {
      finish: "Foil",
      name: "Static",
      catalogId: "F097",
      onchainEditionId: 216,
      maxSupply: 2352,
      cid: "bafkreid4ybhackc2dxrsc2nw2pkv4ost5z5lmkjme5fltqcqmgeos5fuwy",
    },
    {
      finish: "Serialized",
      name: "Static",
      catalogId: "SE097",
      onchainEditionId: 336,
      maxSupply: 99,
      cid: null,
    },
  ],
  "098": [
    {
      finish: "Base",
      name: "Signal Rift",
      catalogId: "098",
      onchainEditionId: 97,
      maxSupply: 3625,
      cid: "bafkreigkhp2p2rprudrhfaj7ilegegy4xjqaaa6hffxiqdnwn55vck4zzy",
    },
    {
      finish: "Foil",
      name: "Signal Rift",
      catalogId: "F098",
      onchainEditionId: 217,
      maxSupply: 384,
      cid: "bafkreiaauo34b3noqvjhmrtmlpvgk7ffyiwg2rhdsj7my7iqdodbwbysv4",
    },
    {
      finish: "Serialized",
      name: "Signal Rift",
      catalogId: "SE098",
      onchainEditionId: 337,
      maxSupply: 5,
      cid: "bafkreidpnuntcbp5g7fzuinwtpwuskmj2npjgzhqpeftoqyqulz4o4ktka",
    },
  ],
  "099": [
    {
      finish: "Base",
      name: "Hall of Mirrors",
      catalogId: "099",
      onchainEditionId: 98,
      maxSupply: 3625,
      cid: "bafkreicxohkvooxklgt3cavooyz2qj3iqcxmejf2tyge25sfv5mac3rqtm",
    },
    {
      finish: "Foil",
      name: "Hall of Mirrors",
      catalogId: "F099",
      onchainEditionId: 218,
      maxSupply: 384,
      cid: "bafkreiayy5aypc5auuvfmhs355b5chtf2l3bll4nfmpt4iiwtpetilbmpu",
    },
    {
      finish: "Serialized",
      name: "Hall of Mirrors",
      catalogId: "SE099",
      onchainEditionId: 338,
      maxSupply: 5,
      cid: "bafkreia65q5w4mmlkj3ytpu2zv7rtywnmcuvepgo7rjea3anrcekxa2xxa",
    },
  ],
  100: [
    {
      finish: "Base",
      name: "Black Flag",
      catalogId: "100",
      onchainEditionId: 99,
      maxSupply: 1319,
      cid: "bafkreifvklkabdi7oxydzm4hmd4pj4pw2euzaamyad6bxvp3pegjejfxdm",
    },
    {
      finish: "Foil",
      name: "Black Flag",
      catalogId: "F100",
      onchainEditionId: 219,
      maxSupply: 136,
      cid: "bafkreid32hsqqs3nmfuulaes5ngho6rytsn7cgw3v7osehzppruyvduv6u",
    },
    {
      finish: "Serialized",
      name: "Black Flag",
      catalogId: "SE100",
      onchainEditionId: 339,
      maxSupply: 1,
      cid: "bafkreibybwofbacp2q74w4n4wht4xtkuqebuhavui673is4hzhaa44qeye",
    },
  ],
  101: [
    {
      finish: "Base",
      name: "The Degen",
      catalogId: "101",
      onchainEditionId: 100,
      maxSupply: 21877,
      cid: "bafkreifyu5ev7su6cb4ivpytap7x4gt3hvsqg3ms6y5qviax4nul2yhzzi",
    },
    {
      finish: "Foil",
      name: "The Degen",
      catalogId: "F101",
      onchainEditionId: 220,
      maxSupply: 2352,
      cid: "bafkreidlec7etwfcuuc7hfk5drqfecyb4j76n3wdig6gua35cokpz6uvbu",
    },
    {
      finish: "Serialized",
      name: "The Degen",
      catalogId: "SE101",
      onchainEditionId: 340,
      maxSupply: 99,
      cid: null,
    },
  ],
  102: [
    {
      finish: "Base",
      name: "The Fisherman",
      catalogId: "102",
      onchainEditionId: 101,
      maxSupply: 21877,
      cid: "bafkreibakdc2voejn7vu6uofi5icdgzjzsz2ivt7hhvmoi2pxxnfb3bon4",
    },
    {
      finish: "Foil",
      name: "The Fisherman",
      catalogId: "F102",
      onchainEditionId: 221,
      maxSupply: 2352,
      cid: "bafkreidtsmopaw4d3ynet5csubes6ehotbe5xpe2ho2co22j7emczsy3ae",
    },
    {
      finish: "Serialized",
      name: "The Fisherman",
      catalogId: "SE102",
      onchainEditionId: 341,
      maxSupply: 99,
      cid: null,
    },
  ],
  103: [
    {
      finish: "Base",
      name: "The Sardines",
      catalogId: "103",
      onchainEditionId: 102,
      maxSupply: 21877,
      cid: "bafkreifhywj2u7lrwwfmpqvgiszz2cjntiohqohttsmkklhg77gtzeguaq",
    },
    {
      finish: "Foil",
      name: "The Sardines",
      catalogId: "F103",
      onchainEditionId: 222,
      maxSupply: 2352,
      cid: "bafkreifkb5zjuv6e3c3e4ijetnohmdons5yz4zorkz5nfn6psp2apavnq4",
    },
    {
      finish: "Serialized",
      name: "The Sardines",
      catalogId: "SE103",
      onchainEditionId: 342,
      maxSupply: 99,
      cid: null,
    },
  ],
  104: [
    {
      finish: "Base",
      name: "The Full Moon",
      catalogId: "104",
      onchainEditionId: 103,
      maxSupply: 21877,
      cid: "bafkreich6sqvv2lc734fsxpl5f2chxygybbibc23gjsyv3ict6lbimthzu",
    },
    {
      finish: "Foil",
      name: "The Full Moon",
      catalogId: "F104",
      onchainEditionId: 223,
      maxSupply: 2352,
      cid: "bafkreiabqessbaw2dzcithim55scdosve3gnlhumrbebdh6yesit234bgu",
    },
    {
      finish: "Serialized",
      name: "The Full Moon",
      catalogId: "SE104",
      onchainEditionId: 343,
      maxSupply: 99,
      cid: null,
    },
  ],
  105: [
    {
      finish: "Base",
      name: "The Fool",
      catalogId: "105",
      onchainEditionId: 104,
      maxSupply: 21877,
      cid: "bafkreierviimcowit6odncgrwjsafq3qwz5tx24xipqe2kzyghviydc7i4",
    },
    {
      finish: "Foil",
      name: "The Fool",
      catalogId: "F105",
      onchainEditionId: 224,
      maxSupply: 2352,
      cid: "bafkreihv72klk4644j6hihwqjipj72scijohxus4k5ygojxk7utnodgylu",
    },
    {
      finish: "Serialized",
      name: "The Fool",
      catalogId: "SE105",
      onchainEditionId: 344,
      maxSupply: 99,
      cid: null,
    },
  ],
  106: [
    {
      finish: "Base",
      name: "The Prophet",
      catalogId: "106",
      onchainEditionId: 105,
      maxSupply: 1319,
      cid: "bafkreigkhffu2pkq76zxwonatxlkzswn7jgke2s3aueqght52c6uj43xau",
    },
    {
      finish: "Foil",
      name: "The Prophet",
      catalogId: "F106",
      onchainEditionId: 225,
      maxSupply: 136,
      cid: "bafkreifnfjztuneoyyjqcueojoq5nqon2on57u6l23ze3qdfestnenm3te",
    },
    {
      finish: "Serialized",
      name: "The Prophet",
      catalogId: "SE106",
      onchainEditionId: 345,
      maxSupply: 1,
      cid: "bafkreibpdpokswlslkzpnjjoweeybfouxxuwudog3q47eo7jbffeec5sni",
    },
  ],
  107: [
    {
      finish: "Base",
      name: "The Cult",
      catalogId: "107",
      onchainEditionId: 106,
      maxSupply: 21877,
      cid: "bafkreid36kflkxn2dntvnk4pzfezwnxyy634ll7w2gsxcsvvimej5lqyny",
    },
    {
      finish: "Foil",
      name: "The Cult",
      catalogId: "F107",
      onchainEditionId: 226,
      maxSupply: 2352,
      cid: "bafkreidkxiyxjtdlz2lu57wkkttdy4xgy6srrt25wc2xmpwboonc4fatbq",
    },
    {
      finish: "Serialized",
      name: "The Cult",
      catalogId: "SE107",
      onchainEditionId: 346,
      maxSupply: 99,
      cid: null,
    },
  ],
  108: [
    {
      finish: "Base",
      name: "The Swamp",
      catalogId: "108",
      onchainEditionId: 107,
      maxSupply: 21877,
      cid: "bafkreicmzkkoj5t5yivjuicgevj3qxs77otbkj67znqir4xbkq73ya4r3i",
    },
    {
      finish: "Foil",
      name: "The Swamp",
      catalogId: "F108",
      onchainEditionId: 227,
      maxSupply: 2352,
      cid: "bafkreihcre2a73rvjswwqpx7azd2sdyw7l6bskqdhag7oi76sqvhvnpv4i",
    },
    {
      finish: "Serialized",
      name: "The Swamp",
      catalogId: "SE108",
      onchainEditionId: 347,
      maxSupply: 99,
      cid: null,
    },
  ],
  109: [
    {
      finish: "Base",
      name: "Fossil Record",
      catalogId: "109",
      onchainEditionId: 108,
      maxSupply: 21877,
      cid: "bafkreididcpvc4tow3sidti32a4egw3tcjdffehqzybrtpkncnug5nlsmy",
    },
    {
      finish: "Foil",
      name: "Fossil Record",
      catalogId: "F109",
      onchainEditionId: 228,
      maxSupply: 2352,
      cid: "bafkreifv6oua7nl5csaikz2lyypzqr2betbmitzp6hr34c3z4vqkif74g4",
    },
    {
      finish: "Serialized",
      name: "Fossil Record",
      catalogId: "SE109",
      onchainEditionId: 348,
      maxSupply: 99,
      cid: null,
    },
  ],
  110: [
    {
      finish: "Base",
      name: "Still Here",
      catalogId: "110",
      onchainEditionId: 109,
      maxSupply: 21877,
      cid: "bafkreic2cu6p6hg53khgbhosg7qogudca3zjhfrmjzqkvlyimw2tnhence",
    },
    {
      finish: "Foil",
      name: "Still Here",
      catalogId: "F110",
      onchainEditionId: 229,
      maxSupply: 2352,
      cid: "bafkreif4nmp457c2zwsefo5epvadnfnnpp5zfby3oapl6dg4lz6gs6dzru",
    },
    {
      finish: "Serialized",
      name: "Still Here",
      catalogId: "SE110",
      onchainEditionId: 349,
      maxSupply: 99,
      cid: null,
    },
  ],
  111: [
    {
      finish: "Base",
      name: "Stone Mosaic",
      catalogId: "111",
      onchainEditionId: 110,
      maxSupply: 24059,
      cid: "bafkreigffbn2nk7nl3su2l7i37357zoryivgrcla5shw2sgyb2y2r7bgdy",
    },
    {
      finish: "Foil",
      name: "Stone Mosaic",
      catalogId: "F111",
      onchainEditionId: 230,
      maxSupply: 2587,
      cid: "bafkreic74rbvlv4kiayhbcfjhumdhbxjtojimhjf5nm6hc2ypqwaa5vehm",
    },
    {
      finish: "Serialized",
      name: "Stone Mosaic",
      catalogId: "SE111",
      onchainEditionId: 350,
      maxSupply: 50,
      cid: null,
    },
  ],
  112: [
    {
      finish: "Base",
      name: "Swamp Foxfire",
      catalogId: "112",
      onchainEditionId: 111,
      maxSupply: 24059,
      cid: "bafkreihnueg43gx4agnwfpg5tqj6rpdbfcafc6extginjzrusn77wipwca",
    },
    {
      finish: "Foil",
      name: "Swamp Foxfire",
      catalogId: "F112",
      onchainEditionId: 231,
      maxSupply: 2587,
      cid: "bafkreibkt6gwn3jafdonudk35al5bdi3ahbjzf7ln4vltgwtddec6rjgf4",
    },
    {
      finish: "Serialized",
      name: "Swamp Foxfire",
      catalogId: "SE112",
      onchainEditionId: 351,
      maxSupply: 50,
      cid: null,
    },
  ],
  113: [
    {
      finish: "Base",
      name: "Heat Signature",
      catalogId: "113",
      onchainEditionId: 112,
      maxSupply: 24059,
      cid: "bafkreicjqn73zkbaiusjedra4lox3xuk36dig6qv473qdzydzwhrfzgc6m",
    },
    {
      finish: "Foil",
      name: "Heat Signature",
      catalogId: "F113",
      onchainEditionId: 232,
      maxSupply: 2587,
      cid: "bafkreiccjgm4n6ta7abfs646mtqi7xoshwmz3rbbgiry3gh6jluzre7q6a",
    },
    {
      finish: "Serialized",
      name: "Heat Signature",
      catalogId: "SE113",
      onchainEditionId: 352,
      maxSupply: 50,
      cid: null,
    },
  ],
  114: [
    {
      finish: "Base",
      name: "The Tonic",
      catalogId: "114",
      onchainEditionId: 113,
      maxSupply: 24059,
      cid: "bafkreicmfbnlnl3w6lvdyz4fc2d46cx53ec6ctwwvhgneroaxxmyrcxd5y",
    },
    {
      finish: "Foil",
      name: "The Tonic",
      catalogId: "F114",
      onchainEditionId: 233,
      maxSupply: 2587,
      cid: "bafkreihmznbenshvp5cdzg65dvm6c7emrbudpjkpxka562prpjoxred7na",
    },
    {
      finish: "Serialized",
      name: "The Tonic",
      catalogId: "SE114",
      onchainEditionId: 353,
      maxSupply: 50,
      cid: null,
    },
  ],
  115: [
    {
      finish: "Base",
      name: "The Beacon",
      catalogId: "115",
      onchainEditionId: 114,
      maxSupply: 24059,
      cid: "bafkreicm4po775obo7lqas3jilm7ht6uqmmqkct6rzx4l4mubbhzrxiayy",
    },
    {
      finish: "Foil",
      name: "The Beacon",
      catalogId: "F115",
      onchainEditionId: 234,
      maxSupply: 2587,
      cid: "bafkreibaetllwdkk3wgek3qyybzdvwftcdvg7qgk2vgyilfto76tvxciii",
    },
    {
      finish: "Serialized",
      name: "The Beacon",
      catalogId: "SE115",
      onchainEditionId: 354,
      maxSupply: 50,
      cid: null,
    },
  ],
  116: [
    {
      finish: "Base",
      name: "Last Meal",
      catalogId: "116",
      onchainEditionId: 115,
      maxSupply: 24059,
      cid: "bafkreigqiqj7zxbp4xdvroseazzkds3cj4j3un42qftu2vsucu7guvfg6u",
    },
    {
      finish: "Foil",
      name: "Last Meal",
      catalogId: "F116",
      onchainEditionId: 235,
      maxSupply: 2587,
      cid: "bafkreihcwtg6qhcjccojrjqy767hiusbku6g545amamqifgiwqdpk2gvem",
    },
    {
      finish: "Serialized",
      name: "Last Meal",
      catalogId: "SE116",
      onchainEditionId: 355,
      maxSupply: 50,
      cid: null,
    },
  ],
  117: [
    {
      finish: "Base",
      name: "The Drip",
      catalogId: "117",
      onchainEditionId: 116,
      maxSupply: 21877,
      cid: "bafkreiadxt5wvz6lpx4n4ekwnjin3kwiy27crntk7kp25g52t2noo5mb6a",
    },
    {
      finish: "Foil",
      name: "The Drip",
      catalogId: "F117",
      onchainEditionId: 236,
      maxSupply: 2352,
      cid: "bafkreieu4gsce4plgs3vgx4sywpxfublose2ohck5gbxoltwvmhzgx2k7e",
    },
    {
      finish: "Serialized",
      name: "The Drip",
      catalogId: "SE117",
      onchainEditionId: 356,
      maxSupply: 99,
      cid: null,
    },
  ],
  118: [
    {
      finish: "Base",
      name: "Sun Dog",
      catalogId: "118",
      onchainEditionId: 117,
      maxSupply: 3625,
      cid: "bafkreidmlda74zyjqgfz5ii7jnbiakipqexnidzs3th2mhqjfxukcngrua",
    },
    {
      finish: "Foil",
      name: "Sun Dog",
      catalogId: "F118",
      onchainEditionId: 237,
      maxSupply: 384,
      cid: "bafkreid5x3llt37yzbsf6x3znzyulf27uf2umy634ix3xt6zpnx5i2glqu",
    },
    {
      finish: "Serialized",
      name: "Sun Dog",
      catalogId: "SE118",
      onchainEditionId: 357,
      maxSupply: 5,
      cid: "bafkreihnunavatcnj5ifid4ryfarj4zshcpxb74ozntckgr3crwiunq4si",
    },
  ],
  119: [
    {
      finish: "Base",
      name: "Blissfully Unbothered",
      catalogId: "119",
      onchainEditionId: 118,
      maxSupply: 3625,
      cid: "bafkreihkbo4y2fjqcmlpxhwblovqgen5rhsoisznawh776wdoywb7htjae",
    },
    {
      finish: "Foil",
      name: "Blissfully Unbothered",
      catalogId: "F119",
      onchainEditionId: 238,
      maxSupply: 384,
      cid: "bafkreigehnjzldrusdi5cwnqtjwsyburbkqspte5fqkyx23t273v3m6t4m",
    },
    {
      finish: "Serialized",
      name: "Blissfully Unbothered",
      catalogId: "SE119",
      onchainEditionId: 358,
      maxSupply: 5,
      cid: "bafkreiciki7rgmpa5yhwqeq6gt6gakayzmsuxatuuapvhzemdbcpilil2m",
    },
  ],
  120: [
    {
      finish: "Base",
      name: "The High Priest",
      catalogId: "120",
      onchainEditionId: 119,
      maxSupply: 1319,
      cid: "bafkreie7koca5or36n27tsr4sp3zfeghlqme2ntzregvxbkr4oo2mgl4iu",
    },
    {
      finish: "Foil",
      name: "The High Priest",
      catalogId: "F120",
      onchainEditionId: 239,
      maxSupply: 136,
      cid: "bafkreih3ukcxavr5v2lutdoaeuryl6n4qyobgrfqnsamj2dfmatyfxxtym",
    },
    {
      finish: "Serialized",
      name: "The High Priest",
      catalogId: "SE120",
      onchainEditionId: 359,
      maxSupply: 1,
      cid: "bafkreifskzf4pfzribf32djwz5m4ngaliv5fyeki63cflk5qlweefbgpoy",
    },
  ],
};
